import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["id", "name", "value", "placeholder"]

import {
	ref,
	computed,
	nextTick
} from 'vue';
import AppIcon from '@/components/ui-kit/icon/AppIcon.vue';
import AppTooltip from '@/components/ui-kit/tooltip/AppTooltip.vue';

import '@/styles/inputs.scss';

type AppTextareaProps = {
	modelValue: string | null,
	id?: string,
	name?: string,
	height?: string | number,
	floatingLabel?: string,
	placeholder?: string,
	clearFieldHint?: string,
	error?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AppTextarea',
  props: {
    modelValue: {},
    id: { default: 'textarea-input-elm' },
    name: { default: 'textarea' },
    height: { default: 150 },
    floatingLabel: {},
    placeholder: {},
    clearFieldHint: { default: 'Очистить поле' },
    error: { type: Boolean }
  },
  emits: [
	'update:modelValue',
	'input',
	'focus',
	'blur',
	'clear'
],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const textareaRef = ref<HTMLTextAreaElement>();
const isFocused = ref(false);

const textareaStyles = computed(() => ({
	height: typeof props.height === "string"
		? props.height
		: `${props.height}px`
}))

const handleInput = (event: Event) => {
	const target = event.target as HTMLTextAreaElement;
	emit('update:modelValue', target.value);
	emit('input', target.value);
};

const onFocus = () => {
	isFocused.value = true;
	emit('focus');
};

const onBlur = () => {
	isFocused.value = false;
	emit('blur');
};

const clearField = () => {
	emit('update:modelValue', '');
	emit('clear');
	nextTick(() => {
		isFocused.value = true;
		textareaRef.value?.focus();
	});
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-wrapper login-wrapper", { 'focused': isFocused.value || _ctx.modelValue }])
  }, [
    _createElementVNode("textarea", {
      ref_key: "textareaRef",
      ref: textareaRef,
      class: _normalizeClass({
				'app-textarea': true,
				'app-textarea--error': props.error
			}),
      style: _normalizeStyle(textareaStyles.value),
      id: _ctx.id,
      name: _ctx.name,
      value: _ctx.modelValue,
      placeholder: props.placeholder,
      onInput: handleInput,
      onFocus: onFocus,
      onBlur: onBlur
    }, null, 46, _hoisted_1),
    (_ctx.modelValue && _ctx.modelValue.length > 0)
      ? (_openBlock(), _createBlock(AppTooltip, {
          key: 0,
          class: "app-textarea__clear",
          text: _ctx.clearFieldHint
        }, {
          activator: _withCtx(() => [
            _createVNode(AppIcon, {
              name: "arrow-left",
              width: "16px",
              color: "#979797",
              cursor: "pointer",
              onClick: clearField,
              onMousedown: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
            })
          ]),
          _: 1
        }, 8, ["text"]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})